import { IUseGraphqlWatchQueryOptions } from '@proscom/prostore-apollo-react';
import { skipIfNull } from '@proscom/prostore';
import { UserFilter, UserType } from '../types';
import { useAuthGraphqlQuery } from '../../common/hooks/utils/useAuthGraphqlQuery';
import { QUERY_GET_USER } from '../queries/users';

const queryOptions: IUseGraphqlWatchQueryOptions<
  { id: string; filter?: UserFilter } | null,
  UserType | null
> = {
  query: QUERY_GET_USER,
  skipQuery: skipIfNull(null),
  mapData: (result) => result.user
};

export function useUser(id?: string, filter?: UserFilter) {
  return useAuthGraphqlQuery({
    queryOptions,
    variables: id && filter ? { id, filter } : id ? { id } : null
  });
}
